import React, { useContext } from "react";
import styles from "./HighlightCard.module.css";

import { VendorContext } from "../../../context";

const HighlightCard = ({ label, payment, months, rate, handleClick, rateCheck, thisProposalIsFastTracked, paymentSelectorOptionsForThisCard }: { label: any, payment: any, months: any, rate: any, handleClick: any, rateCheck?: any, thisProposalIsFastTracked?: any, paymentSelectorOptionsForThisCard?: any }) => {
  const { color: vendorColor } = useContext(VendorContext);
  const showInterestRate = paymentSelectorOptionsForThisCard ? paymentSelectorOptionsForThisCard.showInterestRate : false;

  return rateCheck > 15 ? (
    <div className={styles.card} style={{ backgroundColor: vendorColor }} onClick={handleClick}>
      <p className={styles.label}>{label}</p>
      <p >{`$${payment}/mo.`}</p>
      <p>for {months} months</p>
      <p>
        <strong>See Details</strong>
      </p>
    </div>
  ) : (
    <div className={styles.card} style={{ backgroundColor: vendorColor }} onClick={handleClick}>
      <p className={styles.label}>{label}</p>
      <p >{`$${payment}/mo.`}</p>
      <p>
        for {months} months {!showInterestRate ? "" : `at ${rate}%`}
      </p>
      <p>
        <strong>See Details</strong>
      </p>
    </div>
  );
};

export default HighlightCard;
